import { render, staticRenderFns } from "./tableGroup.vue?vue&type=template&id=4bb856b6"
import script from "./tableGroup.vue?vue&type=script&lang=js"
export * from "./tableGroup.vue?vue&type=script&lang=js"
import style0 from "./tableGroup.vue?vue&type=style&index=0&id=4bb856b6&prod&lang=css"
import style1 from "./tableGroup.vue?vue&type=style&index=1&id=4bb856b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports